import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios';
import { clarityEvent } from '../utils/clarity';
import './QuoteCartPage.css'; // Reusing your existing styles

const MyCartsPage = () => {
    const [carts, setCarts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        api.get('/quotes/my-carts')
            .then(res => {
                setCarts(res.data || []);
                clarityEvent('my_carts_viewed');
                setIsLoading(false);
            })
            .catch(err => {
                setError('Could not load your shared carts.');
                setIsLoading(false);
            });
    }, []);

    if (isLoading) return <div className="loading-state">Loading your carts...</div>;

    return (
        <div className="qcp-wrapper">
            <div className="qcp-header">
                <div className="qcp-header__left">
                    <h1 className="qcp-header__title">My Curated Carts</h1>
                </div>
            </div>

            <div className="qcp-body qcp-body--centered">
                <div className="qcp-panel" style={{ width: '100%', maxWidth: '1000px' }}>
                    {error ? (
                        <div className="qcp-error">{error}</div>
                    ) : carts.length === 0 ? (
                        <div className="qcp-cart-empty">
                            <div className="qcp-cart-empty__icon">🛒</div>
                            <div>No carts have been shared with you yet.</div>
                        </div>
                    ) : (
                        <div className="qcp-table-wrap">
                            <table className="qcp-table">
                                <thead>
                                    <tr>
                                        <th>Status</th>
                                        <th>Cart Name</th>
                                        <th>Items</th>
                                        <th>Created On</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {carts.map(c => (
                                        <tr key={c.id}>
                                            <td>
                                                <span style={{
                                                    padding: '4px 8px', borderRadius: '4px', fontSize: '0.8rem', fontWeight: 'bold',
                                                    backgroundColor: c.status === 'QUOTE' ? '#e6f4ea' : '#fef0d9',
                                                    color: c.status === 'QUOTE' ? '#137333' : '#b06000'
                                                }}>
                                                    {c.status || 'CART'}
                                                </span>
                                            </td>
                                            <td style={{fontWeight: 600}}>{c.cartName}</td>
                                            <td>{c.items?.length ?? 0}</td>
                                            <td>{new Date(c.createdAt).toLocaleDateString()}</td>
                                            <td>
                                                {/* Notice how this perfectly routes to the collaborative workspace! */}
                                                <button
                                                    className="qcp-btn qcp-btn--primary"
                                                    style={{ padding: '0.4rem 1rem' }}
                                                    onClick={() => navigate(`/shared-cart?id=${c.id}`)}
                                                >
                                                    {c.status === 'QUOTE' ? '📄 View Quote' : '✏️ Open Cart'}
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MyCartsPage;